import FormField from "../form-field";

export default class CheckboxField extends FormField {
    constructor(props = {}) {
        super(props);
    }

    _beforeInit() {
        this.altDataType = this.props.altDataType != null ? this.props.altDataType : false;

        if (this.controller.value && !Array.isArray(this.controller.value)) {
            throw new Error('CheckboxField: Value must be an array!');
        }
    }

    _initElements() {
        super._initElements();
        this.$checkboxes = this.$input.querySelectorAll('input[type="checkbox"]');

        if (!this.$checkboxes.length) {
            throw new Error('CheckboxField: Checkboxes are not defined!');
        }
    }

    _afterInit() {
        this.$checkboxes.forEach(($checkbox) => {
            $checkbox.addEventListener('change', this._handleChange.bind(this));
        });
        this._sync();
    }

    _getValue() {
        let value = Array.from(this.$checkboxes)
            .reduce((acc, $checkbox) => {
                acc[$checkbox.value] = $checkbox.checked;
                return acc;
            }, {});

        if (!this.altDataType) {
            value = Object.keys(value).filter((key) => value[key]);
        }

        return value;
    }

    _handleChange(e) {
        this.controller.setValue(this._getValue());
        this._setStatus(this.controller.valid ? 'valid' : 'neutral');
    }

    _setChecked(value) {
        const $checkbox = Array.from(this.$checkboxes).find(($checkbox) => $checkbox.value === value);

        if ($checkbox) {
            return;
        }

        $checkbox.checked = true;
        $checkbox.dispatchEvent(new Event('change'));
    }

    _setAllUnchecked() {
        this.$checkboxes.forEach(($checkbox) => {
            if ($checkbox.checked) {
                $checkbox.checked = false;
                $checkbox.removeAttribute('checked');
                $checkbox.dispatchEvent(new Event('change'));
            }
        });
    }

    _refresh() {
        const value = this.controller.getValue();

        if (value && value.length) {
            value.forEach((item) => this._setChecked(item));
        } else {
            this._setAllUnchecked();
        }
    }

    _sync() {
        this.controller.setValue(this._getValue());
    }

    _reinit($root) {
        this.$root = $root;
        this._initElements();
        this._addSubscriptions();
        this._afterInit();
    }
}